var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNearcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.25a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5z",
    fill: "#1A6751"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.929 12.929a1.25 1.25 0 1 0-1.768-1.768 12.491 12.491 0 0 0 0 17.678 1.25 1.25 0 1 0 1.768-1.768 9.993 9.993 0 0 1 0-14.142zM32.5 20a12.465 12.465 0 0 0-3.661-8.839 1.248 1.248 0 0 0-2.039.405 1.249 1.249 0 0 0 .271 1.363 9.99 9.99 0 0 1 0 14.142 1.25 1.25 0 1 0 1.768 1.768 12.465 12.465 0 0 0 3.661-8.84z",
    fill: "#54897A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.027 26.325A16.235 16.235 0 0 1 8.51 8.509a1.25 1.25 0 0 0-1.768-1.767 18.735 18.735 0 0 0 0 26.516A1.25 1.25 0 0 0 8.51 31.49a16.195 16.195 0 0 1-3.483-5.165zM37.276 12.701a18.683 18.683 0 0 0-4.018-5.96A1.25 1.25 0 0 0 31.49 8.51a16.234 16.234 0 0 1 0 22.98 1.25 1.25 0 1 0 1.768 1.768 18.77 18.77 0 0 0 4.018-20.557z",
    fill: "#54897A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearcast);
export default __webpack_public_path__ + "static/media/nearcast.ccdf7fcbf1dc848c02bc6b1212d76cdb.svg";
export { ForwardRef as ReactComponent };